var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: _vm.localActive,
      callback: function callback($$v) {
        _vm.localActive = $$v;
      },
      expression: "localActive"
    }
  }, [_c('div', {
    directives: [{
      name: "touch",
      rawName: "v-touch",
      value: _vm.fullscreenTouchHandlers,
      expression: "fullscreenTouchHandlers"
    }],
    ref: "fullscreenRoot",
    staticClass: "fullscreen-root",
    on: {
      "!contextmenu": function contextmenu($event) {
        $event.preventDefault();
        return _vm.onFullscreenContextMenu.apply(null, arguments);
      }
    }
  }, [_c('v-toolbar', {
    staticClass: "fullscreen-toolbar",
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_vm.currentItem ? _c('div', {
    staticClass: "fullscreen-title"
  }, [_c('div', {
    staticClass: "fullscreen-title__name"
  }, [_vm._v(_vm._s(_vm.fullscreenDisplayName))]), _c('div', {
    staticClass: "fullscreen-title__type"
  }, [_vm._v(_vm._s(_vm.fullscreenDisplayType))])]) : _vm._e(), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.currentItem
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('download');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-download")])], 1), !_vm.isDeleteDisabled ? _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.currentItem
    },
    on: {
      "click": _vm.openDeleteDialog
    }
  }, [_c('v-icon', [_vm._v("mdi-delete")])], 1) : _vm._e(), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm.media && _vm.media.length > 1 ? _c('v-btn', {
    staticClass: "fs-nav fs-nav--left",
    attrs: {
      "icon": "",
      "aria-label": "Previous"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.goPrev.apply(null, arguments);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-left")])], 1) : _vm._e(), _vm.media && _vm.media.length > 1 ? _c('v-btn', {
    staticClass: "fs-nav fs-nav--right",
    attrs: {
      "icon": "",
      "aria-label": "Next"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.goNext.apply(null, arguments);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1) : _vm._e(), _c('v-window', {
    staticClass: "fullscreen-window",
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.localIndex,
      callback: function callback($$v) {
        _vm.localIndex = $$v;
      },
      expression: "localIndex"
    }
  }, _vm._l(_vm.media, function (m, idx) {
    return _c('v-window-item', {
      key: "".concat(m.type, "-").concat(m.medium.id),
      attrs: {
        "value": idx
      }
    }, [_c('div', {
      staticClass: "fullscreen-stage",
      on: {
        "dblclick": function dblclick($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.onStageDblClick(m, $event);
        },
        "contextmenu": function contextmenu($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.onStageContextMenu(m, $event);
        }
      }
    }, [m.type === _vm.MediaGalleryItemType.IMAGE ? _c('div', {
      staticClass: "fullscreen-image-pan",
      attrs: {
        "data-fs-image-id": m.medium.id
      }
    }, [_c('img', {
      staticClass: "fullscreen-media fullscreen-media--image",
      class: {
        'is-zoomed': _vm.isImageZoomed(m.medium.id)
      },
      attrs: {
        "src": m.medium.url,
        "alt": "",
        "data-fs-image-id": m.medium.id
      },
      on: {
        "dblclick": function dblclick($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.toggleImageZoom(m.medium.id, $event);
        },
        "touchend": function touchend($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.onImageTouchEnd(m.medium.id, $event);
        },
        "wheel": function wheel($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.onImageWheel(m.medium.id, $event);
        },
        "contextmenu": function contextmenu($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.onImageContextMenu(m.medium.id, $event);
        },
        "pointerdown": function pointerdown($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.onImagePointerDown(m.medium.id, $event);
        },
        "pointermove": function pointermove($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.onImagePointerMove(m.medium.id, $event);
        },
        "pointerup": function pointerup($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.onImagePointerUp(m.medium.id, $event);
        },
        "pointercancel": function pointercancel($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.onImagePointerUp(m.medium.id, $event);
        }
      }
    })]) : _c('div', {
      staticClass: "fullscreen-video"
    }, [m.medium && m.medium.videoJsSrc ? _c('media-gallery-video-player', {
      attrs: {
        "value": m.medium
      }
    }) : _vm._e()], 1)])]);
  }), 1)], 1), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.currentItem && _vm.currentItem.type === _vm.MediaGalleryItemType.VIDEO ? _vm.$t('gallery.deleteVideo') : _vm.$t('gallery.deleteImage'),
      "isDialogActive": _vm.showDeleteDialog,
      "rightText": _vm.$t('delete'),
      "rightColor": 'error',
      "loading": _vm.isDeleteLoading,
      "persistent": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.showDeleteDialog = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.showDeleteDialog = $event;
      },
      "close": function close($event) {
        _vm.showDeleteDialog = false;
      },
      "leftClick": function leftClick($event) {
        _vm.showDeleteDialog = false;
      },
      "rightClick": _vm.confirmDelete
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }